var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSeverity = function SvgIconSeverity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90A9C0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.423 15.64v-5.442c0-3.524-2.743-6.391-6.115-6.391-3.372 0-6.115 2.867-6.115 6.39v5.443A1.79 1.79 0 0 0 2 17.325v1.906c0 .328.267.595.595.595H16.02a.595.595 0 0 0 .595-.595v-1.906c0-.777-.498-1.44-1.192-1.685ZM9.308 4.996c2.716 0 4.926 2.334 4.926 5.202v5.34H4.382v-5.34c0-2.868 2.21-5.202 4.926-5.202Zm6.117 13.64H3.191v-1.311c0-.33.267-.597.596-.597H14.83c.329 0 .596.267.596.597v1.311ZM8.713.04h1.19v2.662h-1.19zM4.925 2.035l.839 1.459-1.032.593-.839-1.46zM.676 4.955 2.61 6.27l-.669.984L.007 5.94zM.352 10.228H1.65v1.19H.352zM17.043 10.228h1.298v1.19h-1.298zM18.536 6.012l-1.865 1.246-.66-.99 1.865-1.245zM14.738 2.843l-.879 1.283-.982-.673.88-1.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.261 9.873h1.19v4.203h-1.19z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSeverity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_severity.b2244c26.svg";
export { ForwardRef as ReactComponent };